import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Collapsible from 'react-collapsible';

import Layout from '../layout';

import styles from '../styles/pages/privacy.scss';
import stylesIcon from '../shared/styles/header.scss';

import SignupPromotion from '../shared/signup-promotion';

class PrivacyPolicy extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showIndex: 0,
        };

        document.title = this.props.intl.formatMessage({ id: 'privacy-policy-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'privacy-policy-title', defaultMessage: 'LEGAL WARNING AND PRIVACY POLICY' });
        }
    }

    setSelectedIndex(index) {
        this.setState({ showIndex: index });
    }

    render() {
        const CollapseTitle = (title, index) => (
            <div className={styles.accordion}>
                <div className="text-justify">
                    {title}
                    <i
                        className={`pe-7s-angle-down pe-1x pe-va font-weight-bold ${stylesIcon.angleDown}`}
                        style={{ fontSize: 20, color: 'blue', display: index !== this.state.showIndex ? 'inline-block' : 'none' }}
                    />
                    <i
                        className={`pe-7s-angle-up pe-1x pe-va font-weight-bold ${stylesIcon.angleUp}`}
                        style={{ fontSize: 20, color: 'blue', display: index === this.state.showIndex ? 'inline-block' : 'none' }}
                    />
                </div>
            </div>
        );

        const Paragraph = (props) => (
            <li style={{ paddingLeft: 15, paddingBottom: 5 }} className="text-justify">
                {props.children}
            </li>
        );

        const KatapulkStrongTag = () => (
            <strong>
                Othar Trade & Logistics Spain
            </strong>
        );

        return (
            <Layout notShowMarginBottom>
                <div className="container">
                    <div className="row">
                        <h4 className={styles.mainText}>
                            <FormattedMessage id="privacy-policy-title" defaultMessage="LEGAL WARNING AND PRIVACY POLICY" />
                        </h4>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className={styles.privacyBackround}>
                                <p className="text-justify" style={{ paddingBottom: 10 }}>
                                    <FormattedMessage
                                        id="privacy-policy-text1"
                                        // eslint-disable-next-line max-len
                                        defaultMessage="This legal notice includes the general conditions of access, navigation, and use of the website www.cubalicores.com / cubalicores.com; as well as the details of the treatment of our clients' data. You must accept this legal notice to navigate the pages of www.cubalicores.com and cubalicores.com, as well as to make a purchase."
                                    />
                                </p>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle1"
                                            defaultMessage=" 1) Introduction"
                                        />,
                                        1,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(1)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle1-text1"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="a. Access to the www.cubalicores.com / cubalicores.com portal is conditioned on the user's prior reading and acceptance of the conditions, terms, communications, warnings, legal notices and other information contained in these Terms and Conditions. Access to it is free, its viewing does not require prior subscription or registration whatsoever, and its use by the user implies express, full and unreserved agreement with all of its content."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle1-text2"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="b. If the User does not agree with the content of these General Conditions for browsing access and use of this website, they will not be able to access or buy the products and services it offers."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle1-text3"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="c. By accepting these terms and conditions, the user affirms and declares that they are of legal age and have sufficient legal capacity to register on this website. Likewise, you expressly and without exception accept that access to and use of this website, its services and the contents of said services take place under your sole and exclusive responsibility, and cannot guarantee www.cubalicores.com / cubalicores.com that in direct access to other Web sites through links (links) can view information that could hurt your sensitivity or cause damage."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle1-text4"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="d. The connections with other Web sites that may exist, as well as the use that the User may make of them, is subject to these conditions, as well as any specific conditions that the aforementioned Web sites require. Any use other than authorized is expressly prohibited."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            e.
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle1-text5"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="may modify this website unilaterally and at any time it deems appropriate, updating its configuration, the terms and conditions of the services and their content, eliminate, limit or suspend them temporarily or permanently, as well as prevent access to them by trying inform the User of said change, as long as circumstances allow it, through its publication on the website, which is why Users are recommended to consult the GC, the General Conditions at each access to the Website of Sale, Legal Notices and Particular Conditions set forth in the different pages that make up the website."
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle2"
                                            defaultMessage=" 2) Characteristics of the web and navigability"
                                        />,
                                        2,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(2)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle2-text1"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="a. Adapted web design. The www.cubalicores.com / cubalicores.com website has a responsive design that allows the client to access the website from different devices, adapting the image and resolution of the website to each device."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle2-text2"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="b. High in account. There is a Register, which is accessed in the MY ACCOUNT section, which the user will complete with the required data and with the acceptance of the legal notice to be able to access the online shopping services of www.cubalicores.com / cubalicores.com."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle2-text3"
                                                defaultMessage="c. Possibility of managing profile data. There is an INFORMATION section, accessed through MY ACCOUNT, in which the user can:"
                                            />
                                            <ul style={{ paddingLeft: 10 }}>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle2-text3-1"
                                                        defaultMessage="i. Manage your personal data"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle2-text3-2"
                                                        defaultMessage="ii. Add recipients"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle2-text3-3"
                                                        defaultMessage="iii. Check available credit or bonuses"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle2-text3-4"
                                                        defaultMessage="iv. Manage orders"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle2-text3-5"
                                                        defaultMessage="v. View the products added to FAVORITES"
                                                    />
                                                </li>
                                            </ul>
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle3"
                                            defaultMessage=" 3) Rights and obligations of the service provider"
                                        />,
                                        3,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(3)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle3-text1"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="a. www.cubalicores.com / cubalicores.com is obliged to provide the services offered on the Web and guarantee the communications that may exist with the client, as well as to respond to claims and queries that may arise."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle3-text2"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="b. www.cubalicores.com / cubalicores.com has the right to suspend temporarily and without prior notice the accessibility of this website, as well as to reserve the right to provide or cancel services, in the event of carrying out operations of maintenance, repair, update or improvement of services."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle3-text3"
                                                defaultMessage="c. The intellectual property rights on the website are owned by"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle3-text4"
                                                defaultMessage="The rights of reproduction, distribution, public communication and transformation belong to the same company."
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle4"
                                            defaultMessage=" 4) Rights and obligations of the user"
                                        />,
                                        4,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(4)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle4-text1"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="The contents of this website are available to the user for their use without any commercial purpose and exclusively for their personal use; and only for these purposes the user can transfer the contents of this website. The user cannot, consequently, distribute, modify, transmit, forward or use in any way such content for commercial purposes."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle4-text2"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="b. At all times, the User must make lawful use of the services of this Website in accordance with current legislation, respecting the intellectual property rights of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle4-text3"
                                                defaultMessage="and possible third parties."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle4-text4"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="c. The User will not carry out through the services that www.cubalicores.com / cubalicores.com makes available to them any action that causes damage or alterations to the contents or hinders the proper functioning of the Web, expressly committing themselves to the sole use of the same to not cause technical problems of any kind, transfer elements that may carry computer viruses or damage, interfere or totally or partially intercept the Web, as well as not to intervene or alter the email of other Users."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle4-text5"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="d. The User's responsibility for the veracity of the data entered, in the event that he did so for any circumstance, is exclusive to the User himself; Therefore, in the event of having provided false or inaccurate information, www.cubalicores.com / cubalicores.com and, where appropriate, the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            <FormattedMessage
                                                id="privacy-policy-subtitle4-text6"
                                                defaultMessage=", reserve the right to prohibit the access to this website."
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle5"
                                            defaultMessage=" 5) Exclusion of guarantees and responsibility for the operation of the website"
                                        />,
                                        5,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(5)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text1"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="a. www.cubalicores.com / cubalicores.com undertakes to work to maintain the continued availability of this website, but neither www.cubalicores.com / cubalicores.com nor the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text2"
                                                // eslint-disable-next-line max-len
                                                defaultMessage=", guarantee the availability and continuity of the operation of this website and its services. In this way, any liability for damages of any nature that may arise from the lack of availability or continuity of the operation of the website and its services and the usefulness that Users could have attributed to this website is excluded."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text3"
                                                defaultMessage="b. www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text4"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="They make personal data privacy systems available to Users that prevent access to them by third parties. www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text5"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="They have implemented all the necessary technical and organizational security measures to guarantee the integrity, confidentiality and availability of the personal data provided by the User. In this sense, the aforementioned companies are exempt from all liability for damages caused in the event of such knowledge."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text6"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="c. Despite the fact that www.cubalicores.com / cubalicores.com have implemented all the appropriate measures to guarantee security in this matter, it does not control or guarantee the absence of viruses or other elements in the contents of this website that may cause alterations in the computer system (software and hardware) of the User or in the electronic documents and files stored in his computer system."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text7"
                                                defaultMessage="d. www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text8"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="are exempt from any responsibility for damages of any kind that may be due to the presence of viruses in the contents that may cause alterations in the computer system, electronic documents, files, etc ..."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text9"
                                                defaultMessage="e. www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text10"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="They have no obligation to control, and do not control, the use that Users make of this website, the services that this website provides, or its contents. In particular, www.cubalicores.com / cubalicores.com does not guarantee that Users will use the website, its services and its contents in accordance with the terms and conditions under the www.cubalicores.com / cubalicores.com domain that may result from time to time of application, or that they do so diligently and prudently."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text11"
                                                defaultMessage="f. www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text12"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="They do not have the obligation to verify, and they do not verify, the identity of the Users of this Web site; nor the veracity of the data that they provide about themselves or recipients."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text13"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="g. The User accepts that the Website has been created and developed in good faith by www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text14"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="with information from internal and external sources and offers it in its current state to Users, which may contain inaccuracies or errors, for which the User exonerates www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle5-text15"
                                                defaultMessage="of any responsibility in relation to the reliability, usefulness or false expectations that the website may produce while browsing it"
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle6"
                                            defaultMessage=" 6) Intellectual property"
                                        />,
                                        6,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(6)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text1"
                                                defaultMessage="a. All rights to the content of this website belong to www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text2"
                                                defaultMessage="; except for those from companies with which you have signed the corresponding contract for the provision of content."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text3"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="b. www.cubalicores.com / cubalicores.com does not transfer to the User of this website any ownership of their own software or third parties; the User is responsible for the medium in which the software is recorded, retaining www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text4"
                                                defaultMessage="all industrial and intellectual property rights including software that may correspond to it."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text5"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="c. The design, images, maps, graphics, brands, labels, distinctive signs or logos of www.cubalicores.com / cubalicores.com, frames, banners, the software and its different source and object codes, etc., of this website are owned by de www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text6"
                                                defaultMessage=", who legitimately and exclusively own the exploitation rights over them."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text7"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="d. The logos or distinctive signs of the Group companies that may appear on this Website during the User's browsing are the property of each of them, legitimately having the exclusive rights of exploitation over them, expressly consenting to their incorporation, where appropriate, to this website."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text8"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="e. The User who accesses this website may not copy, modify, distribute, transmit, reproduce, publish, assign or sell the aforementioned elements; nor create new products or services derived from the information obtained through this website."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text9"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="f. Only viewing and uploading is authorized for the User's personal and non-commercial use, without being able to extend it to third parties or entities. In the case of graphics or designs that appear on this website owned by collaborating companies of www.cubalicores.com / cubalicores.com and collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text10"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="g. Any alteration of this Website or its content by the User is strictly prohibited; as well as the installation of links (links or hyperlinks), links or similar not previously and expressly authorized by www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle6-text11"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="h. www.cubalicores.com / cubalicores.com will ensure that the contents of this website are not pornographic, xenophobic, discriminatory, racist, defamatory, or promote any kind of violence."
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle7"
                                            defaultMessage=" 7) Protection of personal data. In compliance with current regulations for the protection of personal data of users,"
                                        />,
                                        7,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(7)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text1"
                                                defaultMessage="a. www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text2"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="will respect, at all times, the provisions of current regulations on the protection of personal data; and guarantee the confidentiality of personal data. In compliance with current regulations on the protection of personal data, we inform you that the data provided will be processed by www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text3"
                                                defaultMessage=", as of Responsible for the File."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text4"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="b. The provision of personal data, own or of third parties, through the forms provided for this purpose on the www.cubalicores.com / cubalicores.com Website may only be made by persons of legal age."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text5"
                                                defaultMessage="c. The Group entities with access to the personal data of the Users of www.cubalicores.com / cubalicores.com are"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text6"
                                                defaultMessage="(commerce),"
                                            />
                                            {' '}
                                            <strong>Fuego Enterprises, Inc. - OnCuba News / OnCuba Magazine</strong>
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text7"
                                                defaultMessage="(communications) and"
                                            />
                                            {' '}
                                            <strong>OnCuba Travel LLC</strong>
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text8"
                                                defaultMessage="(travel agency)"
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text9"
                                                defaultMessage="d. By accepting this Legal Information, the User authorizes www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text10"
                                                defaultMessage="and to all the Group companies to process the data provided on this website for any of the following purposes:"
                                            />
                                            <ul style={{ paddingLeft: 10 }}>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-1"
                                                        defaultMessage="i. Manage the data to process your online purchase orders."
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-2"
                                                        defaultMessage="ii. Manage user participation in possible events and
                                                        promotional actions"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-3"
                                                        defaultMessage="iii. Manage the selection processes of the"
                                                    />
                                                    {' '}
                                                    <KatapulkStrongTag />
                                                    {' '}
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-4"
                                                        defaultMessage="and the Group companies"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-5"
                                                        defaultMessage="iv. Manage possible relationships between the User of the Website and www.cubalicores.com / cubalicores.com."
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-6"
                                                        // eslint-disable-next-line max-len
                                                        defaultMessage="v. Use the data to send the User of www.cubalicores.com / cubalicores.com to surveys and information and / or documentation of products and / or services requested by the User and / or marketed by www.cubalicores.com / cubalicores.com through various media, including electronic (email and telephony mobile)."
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-7"
                                                        // eslint-disable-next-line max-len
                                                        defaultMessage={'vi. The consent for the use of the User\'s data for the sending of commercial communications through electronic means (email or other current or future) may be revoked by the User at any moment in time, through the section "MY PROFILE” from the www.cubalicores.com / cubalicores.com Website'}
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle7-text10-8"
                                                        // eslint-disable-next-line max-len
                                                        defaultMessage="vii. In any case, for the exercise of the rights of access, rectification, cancellation or opposition, an identified letter must be sent, in which the corresponding request is specified and accompanied by a photocopy of the Identity Card of the interested party, to the following address: C / BARBASTRO 4 1 A HUESCA 22002-HUESCA, Spain."
                                                    />
                                                </li>
                                            </ul>
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text11"
                                                defaultMessage="e. When the User provides their data to www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text12"
                                                // eslint-disable-next-line max-len
                                                defaultMessage=", through any of the forms on the Web, the User will be authorizing the aforementioned companies so that they can process your data in accordance with the purpose of the collection. The data provided will be part of a file, created under the responsibility of the company to which the User provides their data."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text13"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="f. www.cubalicores.com / cubalicores.com informs the User of the existence on this website of links that allow access to different websites of certain entities of the Group, as well as to various organizations or third-party entities whose ownership is not of mercadounico .cubalicores.com / cubalicores.com or Group companies"
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text14"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="g. The User may exercise the rights of access, rectification, cancellation and opposition at the address and before the person responsible for the file indicated in each specific case. In this way, www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            {' '}
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text15"
                                                defaultMessage="aim to guarantee Users the right to information at the time the collection of data is carried out. your data."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text16"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="h. The User will be solely responsible for filling in the forms with false, inaccurate, incomplete or outdated information. All the data provided by the User will be treated confidentially."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text17"
                                                defaultMessage="i. The company to which the User has been able to provide their data, may only transfer them."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle7-text18"
                                                defaultMessage={'j. Part of the services of www.cubalicores.com / cubalicores.com use "cookies". For more information, see our cookie policy.'}
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle8"
                                            defaultMessage=" 8) Links"
                                        />,
                                        8,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(8)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle8-text1"
                                                defaultMessage="a. Without the express consent of www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            <FormattedMessage
                                                id="privacy-policy-subtitle8-text2"
                                                defaultMessage=", no link to this website can be established from any other website."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle8-text3"
                                                defaultMessage="b. If the website had links to other portals, not managed by"
                                            />
                                            {' '}
                                            <KatapulkStrongTag />
                                            <FormattedMessage
                                                id="privacy-policy-subtitle8-text4"
                                                // eslint-disable-next-line max-len
                                                defaultMessage=", all responsibility on the part of the company regarding the control and responsibility of the products or services offered is excluded, as well as the contents and owners."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            c.
                                            {' '}
                                            <KatapulkStrongTag />
                                            <FormattedMessage
                                                id="privacy-policy-subtitle8-text5"
                                                // eslint-disable-next-line max-len
                                                defaultMessage=", are exonerated of all responsibility in relation to the contents and services provided by third parties against any claim of any nature and lawsuits that may be filed in relation to them."
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle9"
                                            defaultMessage=" 9) Nullity and ineffectiveness of the clauses"
                                        />,
                                        9,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(9)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle9-text1"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="a. If it were the case that any content of these terms and conditions was declared null or ineffective, it will only affect the indicated content or part of it."
                                            />
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <Collapsible
                                    trigger={CollapseTitle(
                                        <FormattedMessage
                                            id="privacy-policy-subtitle10"
                                            defaultMessage="10) Applicable law and jurisdiction"
                                        />,
                                        10,
                                    )}
                                    onClose={() => this.setSelectedIndex(0)}
                                    onOpen={() => this.setSelectedIndex(10)}
                                    transitionTime={200}
                                >
                                    <ul>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle10-text1"
                                                defaultMessage="a. The Terms and Conditions of this website will be governed by Spanish legislation."
                                            />
                                        </Paragraph>
                                        <Paragraph>
                                            <FormattedMessage
                                                id="privacy-policy-subtitle10-text2"
                                                // eslint-disable-next-line max-len
                                                defaultMessage="b. In the event that any User or affected third party considers that there are facts or circumstances that reveal the illicit nature, they must send a communication containing the following points:"
                                            />
                                            <ul style={{ paddingLeft: 10 }}>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle10-text2-1"
                                                        defaultMessage="i. Complete personal data of the claimant: Name, surname, address, telephone number and email address."
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle10-text2-2"
                                                        // eslint-disable-next-line max-len
                                                        defaultMessage="ii. Specification, in detail, of the following points: What is the alleged illegal content or illegality of the use of the content. If you are the owner of the illegally used content."
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle10-text2-3"
                                                        // eslint-disable-next-line max-len
                                                        defaultMessage="iii. In the case of an alleged injury to property or rights susceptible to compensation, precise and concrete indication of the protected content, as well as its location on the Web."
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle10-text2-4"
                                                        defaultMessage="iv. The claimant must send by post to"
                                                    />
                                                    {' '}
                                                    <strong>Othar Trade & Logistics Spain.</strong>
                                                    <FormattedMessage
                                                        id="privacy-policy-subtitle10-text2-5"
                                                        defaultMessage=", located at C / BARBASTRO 4 1 A HUESCA 22002-HUESCA, Spain the following documentation:"
                                                    />
                                                    <ul style={{ paddingLeft: 10 }}>
                                                        <li>
                                                            <FormattedMessage
                                                                id="privacy-policy-subtitle10-text2-5.1"
                                                                // eslint-disable-next-line max-len
                                                                defaultMessage="1. Communication signed by hand, from the owner of the rights allegedly infringed or from the person authorized to act on her behalf and on her behalf, which is accompanied by documentation proving the ownership of the property or right allegedly injured, in which it refers precisely the data of the Web page, content, or hyperlink object of complaint."
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="privacy-policy-subtitle10-text2-5.2"
                                                                // eslint-disable-next-line max-len
                                                                defaultMessage="2. In case of not being the holder of the right or injured, a sworn statement, express, clear and under the responsibility of the claimant that the information provided in the online notification is accurate and that the content or activity referred to is illegal. The document must be signed by hand and accompany a copy of the Identity Card or equivalent identification document."
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="privacy-policy-subtitle10-text2-5.3"
                                                                // eslint-disable-next-line max-len
                                                                defaultMessage="3. ANONYMOUS COMMUNICATIONS WILL NOT BE ADMITTED AS SUFFICIENT NOTICE TO BRING KNOWLEDGE of www.cubalicores.com / cubalicores.com and the collaborating companies of"
                                                            />
                                                            {' '}
                                                            <KatapulkStrongTag />
                                                            {' '}
                                                            <FormattedMessage
                                                                id="privacy-policy-subtitle10-text2-5.4"
                                                                defaultMessage="THE ILLEGALITY OF CONTENTS OR ACTIVITIES."
                                                            />
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </Paragraph>
                                    </ul>
                                </Collapsible>
                                <p className="text-justify" style={{ paddingTop: 10 }}>
                                    <FormattedMessage
                                        id="privacy-policy-copyright-text1"
                                        defaultMessage="privacy policy copyright"
                                    />
                                    {' '}
                                    <KatapulkStrongTag />
                                    {' '}
                                    <FormattedMessage
                                        id="privacy-policy-copyright-text2"
                                        defaultMessage="Forbidden the total or partial reproduction."
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(PrivacyPolicy);



/** WEBPACK FOOTER **
 ** ./src/components/pages/privacy-policy.jsx
 **/